module.exports = __webpack_public_path__ + "img/70e49a9.png";